import React from "react";
import { Document, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import { commonStyles } from "../../Services/ReactPDFService.jsx";

// Traditional Cover Letter Template - Classic centered design with bordered header
const styles = StyleSheet.create({
  ...commonStyles,
  page: {
    ...commonStyles.page,
    fontFamily: "Roboto",
    backgroundColor: "#ffffff",
    padding: "40 50",
  },
  headerContainer: {
    marginBottom: 20,
    textAlign: "center",
    borderBottom: "1pt solid #cccccc",
  },
  name: {
    fontSize: 22,
    fontWeight: 700,
    color: "#1a1a1a",
    letterSpacing: 2,
    textTransform: "uppercase",
    marginBottom: 6,
  },
  contactInfo: {
    fontSize: 10,
    color: "#555555",
    marginBottom: 1,
  },
  bodyText: {
    fontSize: 11,
    lineHeight: 1.8,
    color: "#333333",
    textAlign: "justify",
  },
});

const TraditionalCoverLetter = ({ coverLetterData }) => {
  const { header, generatedContent } = coverLetterData || {};
  const { name, email, phone, location } = header || {};

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.headerContainer}>
          <Text style={styles.name}>{name || "[Name]"}</Text>
          <Text style={styles.contactInfo}>
            {email || "[Email]"} | {phone || "[Phone]"}
          </Text>
          <Text style={styles.contactInfo}>{location || "[Location]"}</Text>
        </View>
        <Text style={styles.bodyText}>{generatedContent || "No content generated yet."}</Text>
      </Page>
    </Document>
  );
};

export default TraditionalCoverLetter;
